// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/designlens/Documents/designLense Studio th/packages/landing-gatsby/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/designlens/Documents/designLense Studio th/packages/landing-gatsby/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

